/* French display copy for the unpublished Mobile Snap customizer.
 * Keep Teeinblue's input values, IDs, option models and event handlers intact. */
(() => {
  if (!/^fr(?:-|$)/i.test(document.documentElement.lang)) return;
  const copy = new Map(Object.entries({
    'color': 'Couleur', 'size': 'Modèle', 'glossy': 'Brillant', 'matte': 'Mat',
    'default': 'Transparent', 'white': 'Blanc', 'personalize': 'Personnaliser',
    'upload your photo': 'Téléversez votre photo', 'upload a photo': 'Téléverser une photo', 'photo upload': 'Photo téléversée',
    'choose an image': 'Choisir une image', 'choose another image': 'Changer d’image',
    'recustomize image': 'Ajuster l’image', 'preview': 'Aperçu', 'close preview': 'Fermer l’aperçu',
    'quantity': 'Quantité', 'add to cart': 'Ajouter au panier', 'close': 'Fermer',
    'prev': 'Précédent', 'next': 'Suivant', 'previous': 'Précédent',
    'cancel': 'Annuler', 'save': 'Enregistrer', 'done': 'Terminé', 'apply': 'Appliquer',
    'confirm': 'Confirmer', 'reset': 'Réinitialiser', 'reset image': 'Réinitialiser l’image',
    'crop': 'Recadrer', 'crop image': 'Recadrer l’image', 'crop your image': 'Recadrez votre image',
    'edit image': 'Modifier l’image', 'customize image': 'Ajuster l’image',
    'rotate': 'Pivoter', 'rotate left': 'Pivoter à gauche', 'rotate right': 'Pivoter à droite',
    'zoom in': 'Agrandir', 'zoom out': 'Réduire', 'flip horizontal': 'Retourner horizontalement',
    'flip vertical': 'Retourner verticalement', 'move': 'Déplacer',
    'drag to reposition': 'Faites glisser pour repositionner',
    'drag image to reposition': 'Faites glisser l’image pour la repositionner',
    'uploading': 'Téléversement en cours', 'uploading...': 'Téléversement en cours…',
    'loading': 'Chargement en cours', 'loading...': 'Chargement en cours…',
    'processing': 'Traitement en cours', 'processing...': 'Traitement en cours…',
    'remove image': 'Retirer l’image', 'delete image': 'Supprimer l’image',
    'please upload an image': 'Veuillez téléverser une image',
    'please upload a photo': 'Veuillez téléverser une photo',
    'this field is required': 'Ce champ est obligatoire',
    'please select an option': 'Veuillez sélectionner une option',
    'image is too small': 'L’image est trop petite',
    'low image quality': 'La qualité de l’image est insuffisante',
    'try again': 'Réessayer', 'retry': 'Réessayer'
  }));
  const normalize = value => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  const translate = value => copy.get(normalize(value));
  const rootsSelector = '#tee-artwork-form, #tee-gallery, .tee-dialog';
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(localize);
  });
  function localize() {
    queued = false;
    observer.disconnect();
    if (document.querySelector('.ms-pod__hero--landing')) {
      const landingTitle = 'Créez votre étui personnalisé – Mobile Snap';
      if (document.title !== landingTitle) document.title = landingTitle;
      document.querySelectorAll('header [aria-label]').forEach(el => {
        const label = el.getAttribute('aria-label');
        if (label === 'Primary navigation') el.setAttribute('aria-label', 'Navigation principale');
        if (label?.startsWith('Call us at ')) el.setAttribute('aria-label', label.replace('Call us at ', 'Appelez-nous au '));
      });
    }
    document.querySelectorAll(rootsSelector).forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script,style,textarea,svg,[contenteditable="true"],.tee-option--size .tee-radio')) continue;
        const translated = translate(node.nodeValue);
        if (translated && translated !== node.nodeValue.trim()) node.nodeValue = node.nodeValue.replace(/\S[\s\S]*\S|\S/, translated);
      }
      root.querySelectorAll('[aria-label],[title],[placeholder],[alt]').forEach(el => {
        if (el.closest('.tee-option--size .tee-radio')) return;
        ['aria-label', 'title', 'placeholder', 'alt'].forEach(attribute => {
          const translated = translate(el.getAttribute(attribute));
          if (translated && translated !== el.getAttribute(attribute)) el.setAttribute(attribute, translated);
        });
      });
    });
    const finish = document.querySelector('#tee-artwork-form .tee-option--color .tee-option__title');
    if (finish && finish.textContent !== 'Finition' && document.querySelector('#tee-artwork-form .tee-option--color input[value="Glossy"]')) finish.textContent = 'Finition';
    // Match the app's observed SVG controls without relying on button order.
    const tools = [
      ['m-4 7v2h8v-2Z', 'Réduire'], ['m-1 4v3h-3v2h3v3', 'Agrandir'],
      ['M16 3C12 3 8.4 4.8', 'Pivoter à gauche'], ['M16 3C8.832 3 3 8.832', 'Pivoter à droite'],
      ['m13.281 6.781-8.5', 'Déplacer à gauche'], ['M18.719 6.781', 'Déplacer à droite'],
      ['m16 4.094-.719', 'Déplacer vers le haut'], ['M15 4v20.063', 'Déplacer vers le bas']
    ];
    document.querySelectorAll('.tee-dialog-image-placement .tee-toolbar button').forEach(button => {
      const path = button.querySelector('svg path')?.getAttribute('d') || '';
      const name = tools.find(([fragment]) => path.includes(fragment))?.[1];
      if (name) {
        if (button.getAttribute('aria-label') !== name) button.setAttribute('aria-label', name);
        if (button.title !== name) button.title = name;
      }
    });
    document.querySelectorAll('.tee-dialog-image-placement .tee-dcontent-body').forEach(body => {
      if (!body.querySelector('.ms-photo-editor-help')) {
        const help = document.createElement('p');
        help.className = 'ms-photo-editor-help';
        help.textContent = 'Déplacez la photo, ajustez sa taille ou faites-la pivoter. Enregistrez, puis vérifiez votre aperçu.';
        body.prepend(help);
      }
    });
    const title = document.querySelector('.product__title h1')?.textContent.trim();
    if (title) {
      if (document.title !== title + ' – Mobile Snap') document.title = title + ' – Mobile Snap';
      document.querySelectorAll('.product__media-wrapper img, .product-media-modal img').forEach(img => {
        if (/case for|iphone.*case|case.*iphone/i.test(img.alt)) img.alt = title;
      });
    }
    observer.observe(document.body, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','title','placeholder']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', localize, {once:true});
  else localize();
  window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
})();
